import React, { Component } from "react";

import "./index.css";

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count: null,
      page_size: null,
      num_pages: null,
      current_page: null,
      action: null
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        count: this.props.count,
        page_size: this.props.page_size,
        num_pages: this.props.num_pages,
        current_page: this.props.current_page,
        action: this.props.action
      };
    });
  }

  componentWillReceiveProps = nextProps => {
    this.setState(() => {
      return {
        count: nextProps.count,
        page_size: nextProps.page_size,
        num_pages: nextProps.num_pages,
        current_page: nextProps.current_page
      };
    });
  };

  nextPage = () => {
    if (this.state.current_page < this.state.num_pages) {
      this.state.action(false, this.state.current_page+1);
      window.scrollTo(0,0);
    }
  }

  previousPage = () => {
    if (this.state.current_page > 1) {
      this.state.action(false, this.state.current_page-1);
      window.scrollTo(0,0);
    }
  }

  firstPage = () => {
    this.state.action(false, 1);
    window.scrollTo(0,0);
  }

  lastPage = () => {
    this.state.action(false, this.state.num_pages);
    window.scrollTo(0,0);
  }

  goToPage = (num) => {
    this.state.action(false, num);
    window.scrollTo(0,0);
  }

  renderTotalPage = () => {
    const fromNumber = ((this.state.current_page -1) * this.state.page_size) + 1;
    const toNumber = Math.min(this.state.current_page * this.state.page_size, this.state.count);
    return <span className="total-number">{fromNumber+"-"+toNumber+" of "+this.state.count}</span>;
  }

  renderPageNumber = () => {
    const PaginNumber = [];
    const maxNum = this.state.current_page - 4 < 0 ? this.state.current_page + 4 + Math.abs(this.state.current_page - 4)
    : this.state.current_page + 4;
    const minNum = this.state.num_pages - this.state.current_page < 4 ? (this.state.current_page - 7) +
    (this.state.num_pages - this.state.current_page) : this.state.current_page - 4;
    for (let i = 1; i <= this.state.num_pages; i++) {
      if (this.state.current_page === i) {
        PaginNumber.push(<span className="btn-number active" key={i}>{i}</span>);
      } else {
        if (i > minNum && i < maxNum) {
          PaginNumber.push(<a className="btn-number" onClick={() => this.goToPage(i)} key={i}>{i}</a>);
        }
      }
    }
    return (
      <span className="pagin-num-con">
        {this.state.current_page - 4 >= 1 ? "..." : null}
        {PaginNumber}
        {this.state.current_page + 4 <= this.state.num_pages ? "..." : null}
      </span>
    );
  }

  render() {
    return (
      <div className="pagination-con btn-con clearfix">
        {this.renderTotalPage()}
        {this.state.current_page - 4 >= 1
          ? <a className="btn-next" onClick={() => this.firstPage()}>First</a>
          : <a className="btn-next disabled" disabled={true}>First</a>
        }
        <a className={"btn-next"+(this.state.current_page === 1 ? " disabled" : "")}
          onClick={() => this.previousPage()}
          disabled={ this.state.current_page === 1 }
        >
          Prev
        </a>
        {this.renderPageNumber()}
        <a className={"btn-prev"+(this.state.current_page === this.state.num_pages ? " disabled" : "")}
          onClick={() => this.nextPage()}
          disabled={ this.state.current_page === this.state.num_pages }
        >
          Next
        </a>
        {this.state.current_page + 4 <= this.state.num_pages
          ? <a className="btn-prev" onClick={() => this.lastPage()}>Last</a>
          : <a className="btn-next disabled" disabled={true}>Last</a>
        }
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/_components/Pagination/index.js